import React, { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

interface InputDatePickerProps {
    selected?: Date | null;
    handleChange?: (
        date: Date | null,
        event?: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement> | undefined,
    ) => void;
    className?: string;
    inputClassName?: string;
    placeholder?: string;
    disabled?: boolean;
    dateFormat?: string;
    minDate?: Date | null;
    maxDate?: Date;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

const InputDatePicker = ({
    selected,
    handleChange,
    className = "",
    inputClassName = "",
    placeholder = "",
    disabled = false,
    dateFormat = "yyyy.MM.dd",
    minDate,
    maxDate,
    startDate,
    endDate,
}: InputDatePickerProps) => {
    const [newMaxDate, setNewMaxDate] = useState<Date>();
    registerLocale("ko", ko);
    const style = twMerge(
        "relative after:absolute after:content-[''] after:w-[24px] after:h-full after:bg-ic_calendar after:bg-[length:20px_20px] after:top-0 after:right-[12px] after:bg-no-repeat after:bg-center after:pointer-events-none [&>div>.react-datepicker-popper]:z-10 [&>.react-datepicker-wrapper]:w-full",
        className,
    );
    const inputStyle = twMerge(
        "w-full h-[34px] p-[0_44px_0_12px] rounded-[6px] border border-[#E1E2E4] cursor-default placeholder:text-[#878A93]",
        inputClassName,
    );

    useEffect(() => {
        let date = maxDate;
        const oneYearLater = new Date();
        oneYearLater.setMonth(oneYearLater.getMonth() + 12);
        if (!maxDate) {
            date = oneYearLater;
        }
        setNewMaxDate(date);
    }, [maxDate]);

    return (
        <div className={style}>
            <DatePicker
                selected={selected}
                onChange={handleChange}
                locale="ko"
                dateFormat={dateFormat}
                placeholderText={placeholder}
                timeIntervals={60}
                className={inputStyle}
                disabled={disabled}
                minDate={minDate ? minDate : new Date("2000-01-01")}
                maxDate={newMaxDate}
                // startDate={startDate}
                // endDate={endDate}
            />
        </div>
    );
};

export default InputDatePicker;
